import { Reveal } from "../components/Reveal";
import { WaitlistForm } from "../components/WaitlistForm";

export const Community = () => (
  <section className="py-24 sm:py-32" style={{ background: "var(--ink)" }} data-testid="community-section">
    <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
      <Reveal>
        <p className="eyebrow-label mb-5" style={{ color: "#E5A93C" }}>Von Anfang an dabei</p>
        <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-7" style={{ color: "#FBF8F3" }}>
          VisualMA wächst <em style={{ color: "#E5A93C" }}>weiter.</em>
        </h2>
        <div className="text-[15px] sm:text-base leading-relaxed space-y-3 mb-10" style={{ color: "rgba(251,248,243,0.72)" }}>
          <p>Neue Lernwelten, neue Lernlieder und die Entwicklung unserer physischen Bücher:</p>
          <p className="font-medium" style={{ color: "#FBF8F3" }}>Begleite VisualMA von Anfang an.</p>
        </div>
      </Reveal>
      <Reveal delay={0.12} className="flex justify-center">
        <WaitlistForm listType="community" cta="Ich möchte dabei sein" testPrefix="newsletter" />
      </Reveal>
      <Reveal delay={0.2}>
        <p className="text-xs mt-5" style={{ color: "rgba(251,248,243,0.5)" }}>
          Double-Opt-in: Du bestätigst deine Anmeldung per E-Mail. Abmeldung jederzeit möglich.
        </p>
      </Reveal>
    </div>
  </section>
);
